<template>
<div class="tab-songs">
    <songs-list :filter="filter" :request-data="requestData" :playlist-name="playlist.name" :layout="'line'" :tabid="'tab-songs'" :header="header" :showData="showData" :origin="origin"></songs-list>
</div>
</template>

<script>
export default {
    components: {
        'songs-list': require('@/components/Song/List.vue').default,
    },

    props: ['playlist'],
    data() {
        return {
            origin: `playlist.${ this.playlist.user.id == App.user.id ? 'own' : 'other user'} Playlist`,
        }
    },  
  
    computed: {
        isDefault() {
            return isNaN(this.playlist.id);
        },

        filter() {
            return this.isDefault ? 'ReviewedSongs' : 'Search';
        },

        header(){
            return this.isDefault ? 'trending' : null;
        },

        showData(){
            return this.isDefault ? 'trending' : null;
        },

        requestData() {
            if (this.isDefault){
                return {
                    'reviewType': this.playlist.id == 'liked' ? 'liked' : 'disliked', 
                    'published': false,
                    'order_by_financial': 'youtube.daily.desc'
                };
            }else{
                return {
                    'playlists': [this.playlist.id], 
                    'published': false,
                    'order_by_financial': 'youtube.daily.desc'
                };
            }
        }
    }
}
</script>
